import request from '@/utils/request'

/**
 * User login
 * @param {Object} data - Login credentials { phone, password }
 */
export function login(data) {
  return request({
    url: '/api/auth/login',
    method: 'POST',
    data: { ...data, ruleKind: 3 }
  })
}

/**
 * User registration
 * @param {Object} data - Registration data { phone, password, name }
 */
export function register(data) {
  return request({
    url: '/api/auth/register',
    method: 'POST',
    data: { ...data, ruleKind: 3 }
  })
}

/**
 * Send SMS verification code
 * @param {string} phoneNumber - Phone number
 */
export function sendSms(phoneNumber) {
  return request({
    url: '/api/auth/send-sms',
    method: 'POST',
    data: { PhoneNumber: phoneNumber }
  })
}

/**
 * Change password
 * @param {Object} data - { phone, verificationCode, password }
 */
export function changePassword(data) {
  return request({
    url: '/api/auth/change-password',
    method: 'POST',
    data: {
      phone: data.phone || data.phoneNumber,
      phoneNumber: data.phoneNumber || data.phone,
      verificationCode: data.verificationCode || data.code,
      password: data.password || data.newPassword
    }
  })
}

/**
 * Logout
 */
export function logout() {
  return request({
    url: '/api/auth/logout',
    method: 'POST'
  })
}

/**
 * Get user info
 */
export function getUserInfo() {
  return request({
    url: '/api/auth/user-info',
    method: 'GET'
  })
}

/**
 * Refresh token
 */
export function refreshToken() {
  return request({
    url: '/api/auth/refresh',
    method: 'POST'
  })
}

/**
 * Forget password - request password reset
 * @param {Object} data - { phone, verificationCode }
 */
export function forgetPassword(data) {
  return request({
    url: '/api/auth/forget-password',
    method: 'POST',
    data
  })
}

/**
 * Get user profile
 */
export function getUserProfile() {
  return request({
    url: '/api/admin/profile',
    method: 'GET'
  })
}

/**
 * Mini app login
 * @param {Object} data - Mini app login credentials
 */
export function miniAppLogin(data) {
  return request({
    url: '/api/auth/miniapp-login',
    method: 'POST',
    data
  })
}
